import React, { memo } from 'react'
import { useTheme } from 'emotion-theming'

const handleBackToTop = () => {
	window.scrollTo({ top: 0, behavior: 'smooth' })
}

export const BackToTop = memo(() => {
	const {
		backToTop: { mainColor },
	} = useTheme()
	return (
		<svg
			onClick={handleBackToTop}
			xmlns="http://www.w3.org/2000/svg"
			width="110"
			height="86.021"
			viewBox="0 0 110 86.021"
		>
			<g transform="translate(0)">
				<path
					d="M67.871,0A25.171,25.171,0,1,0,93.041,25.171,25.162,25.162,0,0,0,67.871,0Zm15.66,33.466a2.612,2.612,0,0,1-3.718.072l-11.727-11.3L55.929,33.68a2.482,2.482,0,0,1-1.788.715,2.554,2.554,0,0,1-1.931-.858,2.614,2.614,0,0,1,.143-3.718L66.369,16.59a2.658,2.658,0,0,1,3.647,0L83.6,29.676A2.843,2.843,0,0,1,83.531,33.466Z"
					transform="translate(-12.166)"
					fill={mainColor}
				/>
				<text transform="translate(0 82.021)" fill={mainColor} fontSize="18" fontWeight="300">
					<tspan x="7" y="0">
						Back to Top
					</tspan>
				</text>
			</g>
		</svg>
	)
})
